module.exports = __webpack_public_path__ + "img/modelado.ab85e972.png";